import React from 'react'

import { getStoryBackground } from 'components/UI/BackgroundPicker/BackgroundPicker'
import { PostPoll } from 'components-ref/molecules'
import { usePreviewContext } from 'context/previewContext'
import { useAnswerPoll } from 'helpers/hooks'
import { getCachedBlob } from 'helpers/mediaPrefetch'

import { type IProps } from './PollPostWrapper.types'

export const PollPostWrapper = ({
  postData,
  dataQuery,
  postIndex,
  isMyPost
}: IProps) => {
  const previewData = usePreviewContext()
  const { setPollAnswer } = useAnswerPoll(dataQuery, postData.id)

  const poll = postData.poll

  const feedBackgroundSrc =
    poll?.background_src_thumb ||
    poll?.background_src ||
    ''

  const feedBackgroundDisplaySrc =
    feedBackgroundSrc
      ? getCachedBlob(feedBackgroundSrc) ??
        feedBackgroundSrc
      : ''
      
  const handleWrapperClick = () => {
    const {
      minimized,
      updateSelectedPost,
      handleMinimize,
      addModal,
    } = previewData

    if (minimized) {
      updateSelectedPost(postIndex, 0, 'poll', postData, dataQuery)
      handleMinimize(false)
    } else {
      addModal(postIndex, 0, 'poll', postData, dataQuery)
    }
  }

  return (
    <div
      className="post__files__file post__files__file--poll"
      onClick={handleWrapperClick}
      style={
        poll?.background_color
          ? { background: getStoryBackground(poll.background_color) }
          : undefined
      }
    >
    {feedBackgroundDisplaySrc && (
      <img
        className="post__files__pollBg"
        src={feedBackgroundDisplaySrc}
        alt=""
        draggable={false}
      />
    )}

      <PostPoll
        pollData={poll}
        setAnswer={answer => {
          setPollAnswer.mutate(answer)
        }}
        isMyPost={isMyPost}
      />
    </div>
  )
}